const EmployeeService = require('@/services/users/EmployeeService')

export default function (cb, preset) {
  let value = null;

  const data = {
    sort: [{
      key: 'name',
      direction: 'ASC'
    }],
    includes: ['department'],
    filter_groups: [
      {
        filters: [
          {
            key: 'terminated',
            value: 0,
            operator: 'eq'
          },
          {
            key: 'department.title',
            value: 'Sales',
            operator: 'eq'
          }
        ]
      }
    ]
  }

  
  EmployeeService.findAll(data, (response) => {
    const body = response.data;

    const results = body.rows.map((employee) => {
      return {
        label: employee.name,
        value: employee.id
      }
    });

    for (var i = 0; i < results.length; i++) {
      if (results[i].value != preset) {
        continue;
      }

      value = preset;
    }

    cb(results, value);
  });
}
